import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import {
  BmpDashboardConfig,
  MetaData,
  ReportIdentityModel,
  ReportPayload,
  TrackUsageModel
} from '../../models/dashboard.model';
import { Study } from '../../models/peer.model';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { IS_CACHE_ENABLED, USE_CUSTOM_TOKEN } from '../constants/context-token';
import { AuthService } from './auth.service';

@Injectable()
export class CommonService {
  moduleName? = new BehaviorSubject<string | null>(null);
  $selectedReport? = new BehaviorSubject<any | null>(null);
  $reloadReportOnSelection = new BehaviorSubject<boolean>(false);
  $disclaimerDenied= new BehaviorSubject<boolean>(false);
  $BmpDashboardConfig = signal<BmpDashboardConfig[] | null>(null);
  private data: Study[] = [
    {
      name: 'Study 1',
      description: 'Description 1',
      partner: 'Partner 1',
      lastModified: new Date(),
      retainedUntil: new Date(),
    },
  ];

  constructor(
    private http: HttpClient,
    private userService: AuthService
  ) {}

  getData(): Study[] {
    return this.data;
  }

  getReportDetails(): Observable<BmpDashboardConfig[]> {
    const url = API_ENDPOINTS.DASHBOARD.GET_REPORT;
    const context = new HttpContext().set(IS_CACHE_ENABLED, true);
    return this.http.get<any>(url, { context: context }).pipe(
      map(response => {
        return response.map((item: any) => {
          const data: BmpDashboardConfig = {
            dashboardConfigId: item.dashboardConfigId,
            name: item.name,
            reportId: item.reportId,
            workspaceId: item.workspaceId,
            datasetId: item.datasetId,
            description: item.description,
            hasAccess: item.hasAccess,
            redirectURL: item.redirectURL,
            displayName: item.displayName,
            rlsValue: item.rlsValue,
            isRLSEnable: item.isRLSEnable,
          };
          return data;
        });
      })
    );
  }

  getDashboardMetaData(id: string): Observable<MetaData[]> {
    const jsonData = this.generateSampleData();
    const data = jsonData.filter(x => x.id == Number(id));
    const extractedData = jsonData.map(({ key, value }) => ({ key, value }));
    return of(extractedData as MetaData[]);
  }

  generateRandomString = (length: number) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';

    for (let i = 0; i < length; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    return randomString;
  };

  generateSampleData = () => {
    const sampleData = [];

    for (let i = 0; i < 10; i++) {
      const id = i % 2 === 0 ? 2 : 1;
      const key = `kpi_${i + 1}`;
      const value = this.generateRandomString(35); 

      sampleData.push({ id, key, value });
    }

    return sampleData;
  };

  getAccesstokenForDashboardReports(body: ReportPayload): Observable<string> {
    const url = API_ENDPOINTS.DASHBOARD.GET_ACCESS_TOKEN;
    return this.http.post<string>(url, body);
  }

  getPowerBIAccessToken(reportId: string, workspaceId: string, datasetId: string, bearerToken: string, isRLSEnabled = false, RLS?: string): Observable<any> {
    const url = API_ENDPOINTS.POWERBI.TOKEN_URL;
    const context = new HttpContext().set(USE_CUSTOM_TOKEN, bearerToken);
    let requestbody: any = {
      datasets: [{ id: datasetId }],
      reports: [{ id: reportId }],
      targetWorkspaces: [{ id: workspaceId }],
    };
    if (isRLSEnabled && RLS != null) {
      requestbody = {
        ...requestbody,
        identities: [
          {
            username: this.userService.$authState()?.username,
            roles: [RLS],
            datasets: [datasetId],
          },
        ],
      };
    }
    return this.http.post(url, requestbody, { context: context });
  }

  getDashboardAccessDetails(configId: string, email: string) {
    const url = API_ENDPOINTS.DASHBOARD.GET_DASBOARD_ACCESS;
    return this.http.get<any>(url, { params: { ReportId: configId } });
  }

  trackUsageStatusBase(request: TrackUsageModel) {
    const url = API_ENDPOINTS.LOG.LOGACTION;
    return this.http.post(url, request);
  }

  getAccessTokenForReports(request: ReportIdentityModel) {
    const url = API_ENDPOINTS.DASHBOARD.GET_REPORT_TOKEN;
    return this.http.post<any>(url, request);
  }

  trackUsageStatus(KPIName: string, KPIId: string, Form: string, Action: string, ReportId: string) {
    const KPIds = KPIId == '' || KPIId == null ? '' : '{KPIId:' + KPIId + '#KPIName:' + KPIName + '}';
    const gDPRModel = {
      emailAddress: this.userService.$authState()?.username,
      moduleId: parseInt(ReportId),
      page: Form,
      userAction: Action,
      memberFirm: '',
      actionTime: new Date(),
      customInfo1: KPIds,
      customInfo2: KPIds,
      IsAdmin: true,
    };
    const url = API_ENDPOINTS.LOG.LOGACTION;
    return this.http.post(url, gDPRModel);
  }

  downloadFIle(fileName: string, blob: Blob) {
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = fileName;
    a.dispatchEvent(new MouseEvent('click'));
  }

  getReports(){
    const url = API_ENDPOINTS.DASHBOARD.GET_ALL_REPORTS;
    return this.http.get<any>(url);
  } 

  inserUserReportSelection(reportId: number) {
    const report = {
      UserEmail: this.userService.$authState()?.username,
      ReportId: reportId,
     };
    const url = API_ENDPOINTS.DASHBOARD.INSERT_USER_REPORT_SELECTION;
    return this.http.post(url, report);
  }
}
